import React, { useState, useEffect, useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";
import TabPanel from "../serviceList/Tabpanel/TabPanel";
import Box from "@mui/material/Box";
import { Button, Chip } from "@mui/material";
import BookingForm from "../forms/bookingForm/bookingForm";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Popup from "reactjs-popup";
import { baseUrl } from "../../../../network/constants/constants";
import { getConfig } from "../../../../network/auth";
import { Snackbar, Alert } from "@mui/material";
import axios from "../../../../network/api";
import AppConstants from "../../../AppConstants";
import { Spinner } from "react-bootstrap";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const TaskAssign = () => {
  const [bookingData, setBookingData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [serviceList, setServiceList] = useState([]);
  const [bookingToDelete, setBookingToDelete] = useState(null);

  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [data, setData] = useState([]);

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };

  let bID = localStorage.getItem(AppConstants.business_id);

  const fetchBooking = (page) => {
    setLoading(true);
    axios
      .get(
        baseUrl + `businessadmin/booking-history-by-business/${bID}/`,
        config
      )
      .then((response) => {
        setLoading(false);
        setBookingData(response.data);
      })
      .catch((error) => {
        console.error("Category Error:", error);
        setLoading(false);
      });
  };

  const fetchService = () => {
    setLoading(true);
    axios
      .get(baseUrl + `app/services-list-by-business/${bID}`, config)
      .then((response) => {
        setServiceList(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Category Error:", error);
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchBooking();
    fetchService();
  }, []);

  const handleAddForm = () => {
    setSelectedBooking();
    setOpen(true);
  };

  const handleEditForm = (booking = null) => {
    setSelectedBooking(booking);

    setOpen(true);
  };

  const handleCloseForm = () => {
    setSelectedBooking(null);
    setOpen(false);
  };
  const handleDeleteClick = (booking) => {
    setBookingToDelete(booking.id);
    setShowDeletePopup(true);
  };

  const handleBookingSubmit = (formData) => {
    const url = selectedBooking
      ? `${baseUrl}businessadmin/booking-edit/${selectedBooking.id}/`
      : `${baseUrl}businessadmin/add-booking/`;

    const method = selectedBooking ? "patch" : "post";

    const form = new FormData();
    form.append("service_id", formData.serviceName);
    form.append("name", formData.customerName);
    form.append("phone", formData.phone);
    form.append("address", formData.address);
    form.append("booked_date", formData.bookingDate);
    form.append("booked_time", formData.bookingTime);
    form.append("latitude", latitude);
    form.append("longitude", longitude);

    axios({
      method,
      url,
      data: form,
      headers: config.headers,
    })
      .then((response) => {
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        fetchBooking();
        setOpen(false);
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred. Please try again.";
        setSnackbar({
          open: true,
          message: errorMessage,
          severity: "error",
        });
        console.error("Error saving booking details:", error);
      });
  };

  const confirmDelete = () => {
    if (bookingToDelete) {
      deleteBooking(bookingToDelete);
      setBookingToDelete(null);
      setShowDeletePopup(false);
    }
  };

  const deleteBooking = (bookingId) => {
    setLoading(true);

    axios
      .delete(`${baseUrl}businessadmin/bookings/delete/${bookingId}/`, config)
      .then((response) => {
        fetchBooking();
        setLoading(false);
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "success",
        });
      })
      .catch((error) => {
        console.error("Error deleting booking:", error);
        setLoading(false);
      });
  };
  useEffect(() => {
    setData(selectedBooking);
  }, [selectedBooking]);

  return (
    <div>
      <button className="btn-add" onClick={handleAddForm}>
        + Add Booking
      </button>
      {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <Box
          sx={{
            flexGrow: 1,
            maxWidth: { xs: 650, sm: 1000, lg: 1350 },
            bgcolor: "background.paper",
          }}
        >
          <TabPanel>
            <DataGrid
              rows={bookingData}
              columns={[
                { field: "id", headerName: "ID", width: 90 },
                { field: "service", headerName: "Service Name", width: 150 },
                { field: "name", headerName: "Customer", width: 150 },
                { field: "phone", headerName: "Contact Number", width: 150 },
                {
                  field: "address",
                  headerName: "Customer Address",
                  width: 150,
                },
                {
                  field: "booked_date",
                  headerName: "Booking Date",
                  width: 150,
                },
                {
                  field: "booked_time",
                  headerName: "Booking Time",
                  width: 150,
                },

                {
                  field: "status",
                  headerName: "Booking Status",
                  width: 150,
                  renderCell: (params) => {
                    let chipColor;

                    switch (params.value) {
                      case "Waiting":
                        chipColor = "warning";
                        break;
                      case "Accepted":
                        chipColor = "secondary";
                        break;
                      case "Cancelled":
                        chipColor = "error";
                        break;
                      case "Estimated":
                        chipColor = "primary";
                        break;
                      case "Completed":
                        chipColor = "success";
                        break;
                      default:
                        chipColor = "default";
                    }

                    return (
                      <Chip
                        label={params.value}
                        color={chipColor}
                        style={{
                          color: "white",
                          minWidth: "100px",
                        }}
                      />
                    );
                  },
                },

                {
                  field: "actions",
                  headerName: "Actions",
                  width: 200,
                  renderCell: (params) => (
                    <div className="action-btn d-flex justify-content-lg-start">
                      {params.row.status === "Waiting" && (
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => handleEditForm(params.row)}
                        >
                          <EditIcon />
                        </Button>
                      )}
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick(params.row);
                        }}
                      >
                        <DeleteIcon />
                      </Button>
                    </div>
                  ),
                },
              ]}
              pageSizeOptions={[25, 50, 100]}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 25,
                  },
                },
              }}
              disableSelectionOnClick
            />
          </TabPanel>
        </Box>
      )}
      <BookingForm
        open={open}
        onClose={handleCloseForm}
        booking={selectedBooking}
        serviceList={serviceList}
        onSubmit={handleBookingSubmit}
        setLatitude={setLatitude}
        setLongitude={setLongitude}
        latitude={latitude}
        longitude={longitude}
      />
      <Popup
        className="popup-container"
        contentStyle={{
          borderRadius: "20px",
          backgroundColor: "white",
        }}
        open={showDeletePopup}
        onClose={() => setShowDeletePopup(false)}
        modal
        nested
      >
        {(close) => (
          <div className="delete-img-div">
            <h3 className="delete-img-heading">Are you sure?</h3>
            <p className="delete-img-p">Do you really want to delete?</p>
            <div className="delete-btn-div">
              <button onClick={confirmDelete}>Delete</button>
              <button onClick={close}>Cancel</button>
            </div>
          </div>
        )}
      </Popup>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default TaskAssign;
